import React, { useState } from 'react';
import { ChevronDownIcon } from 'lucide-react';
interface FAQItemProps {
  question: string;
  answer: string;
  isOpen: boolean;
  onToggle: () => void;
}
function FAQItem({
  question,
  answer,
  isOpen,
  onToggle
}: FAQItemProps) {
  return <div className="border border-gray-200 rounded-xl overflow-hidden" data-id="element-170">
      <button onClick={onToggle} className="w-full flex items-center justify-between p-5 md:p-6 text-left bg-white hover:bg-gray-50 transition-colors" aria-expanded={isOpen} data-id="element-171">
        <span className="font-heading font-bold text-lg text-gray-900 pr-4" data-id="element-172">
          {question}
        </span>
        <ChevronDownIcon className={`w-6 h-6 text-gold-600 flex-shrink-0 transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`} data-id="element-173" />
      </button>
      <div className={`overflow-hidden transition-all duration-300 ${isOpen ? 'max-h-40 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-174">
        <div className="px-5 md:px-6 pb-5 md:pb-6" data-id="element-175">
          <p className="font-body text-gray-600 leading-relaxed" data-id="element-176">{answer}</p>
        </div>
      </div>
    </div>;
}
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const handleToggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <section className="w-full bg-white py-16 md:py-20 px-4" data-id="element-177">
      <div className="max-w-3xl mx-auto" data-id="element-178">
        <h2 className="font-heading font-bold text-3xl md:text-4xl text-gray-900 text-center mb-10" data-id="element-179">
          ❓ Preguntas frecuentes
        </h2>

        <div className="space-y-4" data-id="element-180">
          <FAQItem question="¿Necesito conocimientos previos?" answer="No. Está diseñado desde cero." isOpen={openIndex === 0} onToggle={() => handleToggle(0)} data-id="element-181" />
          <FAQItem question="¿Es material digital?" answer="Sí. Descarga inmediata en PDF." isOpen={openIndex === 1} onToggle={() => handleToggle(1)} data-id="element-182" />
          <FAQItem question="¿Voy a poder leer el Tarot de verdad?" answer="Sí. Está pensado para que practiques desde el primer día." isOpen={openIndex === 2} onToggle={() => handleToggle(2)} data-id="element-183" />
          <FAQItem question="¿Es solo teoría?" answer="No. Es práctico, con ejercicios reales." isOpen={openIndex === 3} onToggle={() => handleToggle(3)} data-id="element-184" />
        </div>
      </div>
    </section>;
}